package one.devsbox.www.io

import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.cache.*
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.browser.window
import kotlinx.coroutines.*
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock
import one.devsbox.commons.JSON_INSTANCE
import one.devsbox.commons.ads.ApiAds
import one.devsbox.commons.ads.ApiAds.LoginData
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.provider.UserInfoProvider
import org.jetbrains.skia.Image
import org.w3c.dom.get
import org.w3c.dom.set
import tk.mallumo.crypto.internal.base64Url
import tk.mallumo.crypto.internal.fromBase64

object Repository {


    private lateinit var hosts: SharedIO.Hosts

    private val HOST_PORTAL get() = "https://${hosts.main}"

    private val HOST_STORAGE get() = "https://${hosts.storage}"

    val userInfoProvider = UserInfoProvider()
    private val fetchScope = CoroutineScope(Dispatchers.Main.immediate)

    private val cacheImages = mutableMapOf<Long, ImageBitmap>()
    private val activeJobs = mutableMapOf<Long, Deferred<ImageBitmap>>()

    private val mutexImageGlobal = Mutex()

    private val imageClient = HttpClient {
        install(HttpCache) {
            isShared = true
        }
    }

    fun buildUploadUrlIMAGE() = "https://${hosts.storage}/image"
    fun buildUploadUrlVIDEO() = "https://${hosts.storage}/video"

    lateinit var ads: ApiAds
        private set

    var logged: Boolean = false
        private set

    fun logout() {
        window.localStorage.removeItem("account")
        window.location.reload()
    }

    fun setup() {
        val prefix = if ("http://localhost:8080" == window.location.origin) {
            "https://dev.bsoft.systems"
        } else window.location.origin

        val request = org.w3c.xhr.XMLHttpRequest()
        request.open("GET", "$prefix/api/global/hosts", false)
        request.send()
        if (request.status == 200.toShort()) {
            hosts = JSON_INSTANCE.decodeFromString<SharedIO.Hosts>(request.responseText)
        } else {
            error("Failed to fetch hosts: ${request.statusText}")
        }

        window.localStorage["account"]
            ?.fromBase64(url = true)
            ?.decodeToString()
            ?.runCatching { JSON_INSTANCE.decodeFromString<LoginData>(this) }
            ?.getOrNull()
            ?.also {
                CoroutineScope(Dispatchers.Main).launch {
                    runCatching {
                        setup(it)
                    }.onFailure {
                        it.printStackTrace()
                        logout()
                    }
                }
            }?.also {
                logged = true
            }
    }

    suspend fun login(name: String, pass: String): LoginData {
        return ApiAds(url = HOST_PORTAL).login(name, pass)
    }

    suspend fun changePassword(login: LoginData, newPass: String) {
        ApiAds(url = HOST_PORTAL, login = login).user.changePassword(login.userId, newPass)
    }


    suspend fun setup(login: LoginData) {

        fun setupLoginData(login: LoginData) {
            window.localStorage["account"] =
                JSON_INSTANCE.encodeToString(login).encodeToByteArray().base64Url
        }
        setupLoginData(login)

        ads = ApiAds(
            url = HOST_PORTAL,
            login = login
        ) { setupLoginData(it) }

        userInfoProvider.configure(ads.user.me())
        logged = true
    }

    fun contains(id: Long): Boolean = cacheImages.contains(id)
    fun getCached(id: Long): ImageBitmap? = cacheImages[id]

    fun createUrlThumbnail(id: Long) = "${HOST_STORAGE}/image/$id/thumb"
    fun createUrlVideo(id: Long) = "${HOST_STORAGE}/video/$id"
    fun createUrlImage(id: Long) = "${HOST_STORAGE}/image/$id"

    suspend fun fetchThumb(id: Long): ImageBitmap {
        val deferred = mutexImageGlobal.withLock {
            cacheImages[id]?.let { CompletableDeferred(it) }
                ?: activeJobs[id]
                ?: fetchScope.async {
                    try {
                        val bytes = imageClient.get(createUrlThumbnail(id))
                            .takeIf { it.status.isSuccess() }
                            ?.body<ByteArray>() ?: error("fetch fail")

                        val bitmap = Image.makeFromEncoded(bytes).toComposeImageBitmap()
                        bitmap.prepareToDraw()

                        mutexImageGlobal.withLock {
                            cacheImages[id] = bitmap
                            activeJobs.remove(id)
                        }
                        bitmap
                    } catch (t: Throwable) {
                        mutexImageGlobal.withLock {
                            activeJobs.remove(id)
                        }
                        throw t
                    }
                }.also {
                    activeJobs[id] = it
                }
        }
        return deferred.await()
    }
}